<template>
    <div class="py-3">
        <router-view @childrenRoute="hideNonChildren" />
        <div  v-if="!isChildRoute">
            <div class="row">
                <div class="col-md-12 mb-4">
                    <el-card shadow="hover">
                        <div>
                            <div class="mb-1"><h5>PETTY CASH SUMMARY YTD {{ overviewdata?.data?.summary_ytd?.Year }}</h5></div>
                            <div><h3> {{ formatNum(overviewdata?.data?.summary_ytd.Amount) }}</h3></div>
                            <Loader v-if="loading.overview" />
                        </div>
                    </el-card>
                </div>

                <div class="col-md-6 mb-4">
                    <el-card shadow="hover">
                        <div>
                            <h5>TOP 10 PETTY CASH {{ overviewdata?.data?.summary_ytd?.Year }}</h5>
                        </div>
                        <hr class="p-0 mt-2 mb-2">
                        <div style="overflow: auto;">
                            <table class="table-pc-topbottom">
                                <thead>
                                    <tr>
                                        <th class="text-center px-2 py-2">No</th>
                                        <th class="text-center px-2 py-2">COA Id</th>
                                        <th class="px-2 py-2">COA Name</th>
                                        <th class="text-center px-2 py-2">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, idx) in overviewdata?.data?.summary_top" :key="'top-'+idx+'-'+item.COAId">
                                        <td class="text-center align-top px-1 py-2">{{ ++idx }}</td>
                                        <td class="text-center align-top px-2 py-2">{{ item.COAId }}</td>
                                        <td class="align-top px-2 py-2">{{ item.COAName }}</td>
                                        <td class="text-right align-top px-2 py-2">{{ formatNum(item.Amount) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <Loader v-if="loading.overview" />
                    </el-card>
                </div>

                <div class="col-md-6 mb-4">
                    <el-card shadow="hover">
                        <div>
                            <h5>BOTTOM 10 PETTY CASH {{ overviewdata?.data?.summary_ytd?.Year }}</h5>
                        </div>
                        <hr class="p-0 mt-2 mb-2">
                        <div style="overflow: auto;">
                            <table class="table-pc-topbottom">
                                <thead>
                                    <tr>
                                        <th class="text-center px-2 py-2">No</th>
                                        <th class="text-center px-2 py-2">COA Id</th>
                                        <th class="px-2 py-2">COA Name</th>
                                        <th class="text-center px-2 py-2">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, idx) in overviewdata?.data?.summary_bottom" :key="'top-'+idx+'-'+item.COAId">
                                        <td class="text-center align-top px-1 py-2">{{ ++idx }}</td>
                                        <td class="text-center align-top px-2 py-2">{{ item.COAId }}</td>
                                        <td class="align-top px-2 py-2">{{ item.COAName }}</td>
                                        <td class="text-right align-top px-2 py-2">{{ formatNum(item.Amount) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <Loader v-if="loading.overview" />
                    </el-card>
                </div>

                <div class="col-md-12 mb-4" v-if="false">
                    <el-card shadow="hover">
                        <div>
                            <h5>TOP 10 PETTY CASH {{ overviewdata?.data?.summary_ytd?.Year }} BY STATION</h5>
                        </div>
                        <hr class="p-0 mt-2 mb-2">
                        <div style="overflow: auto;">
                            <table class="table-pc-topbottom">
                                <thead>
                                    <tr>
                                        <th class="text-center px-2 py-2">No</th>
                                        <th class="px-2 py-2">Station Id</th>
                                        <th class="px-2 py-2">Station Name</th>
                                        <th class="text-center px-2 py-2">Year</th>
                                        <th class="text-center px-2 py-2">Month</th>
                                        <th class="text-center px-2 py-2">COA Id</th>
                                        <th class="px-2 py-2">COA Name</th>
                                        <th class="text-center px-2 py-2">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, idx) in reportdata?.data?.top" :key="idx+'-'+item.StationId+item.COAId">
                                        <td class="text-center align-top px-1 py-2">{{ ++idx }}</td>
                                        <td class="align-top px-2 py-2">{{ item.StationId }}</td>
                                        <td class="align-top px-2 py-2">{{ item.StationName }}</td>
                                        <td class="text-center align-top px-2 py-2">{{ item.Year }}</td>
                                        <td class="text-center align-top px-2 py-2">{{ item.Month }}</td>
                                        <td class="text-center align-top px-2 py-2">{{ item.COAId }}</td>
                                        <td class="align-top px-2 py-2">{{ item.COAName }}</td>
                                        <td class="text-right align-top px-2 py-2">{{ formatNum(item.Amount) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </el-card>
                </div>

                <div class="col-md-12 mb-4" v-if="false">
                    <el-card shadow="hover">
                        <div>
                            <h5>BOTTOM 10 PETTY CASH {{ overviewdata?.data?.summary_ytd?.Year }} BY STATION</h5>
                        </div>
                        <hr class="p-0 mt-2 mb-2">
                        <div style="overflow: auto;">
                            <table class="table-pc-topbottom">
                                <thead>
                                    <tr>
                                        <th class="text-center px-2 py-2">No</th>
                                        <th class="px-2 py-2">Station Id</th>
                                        <th class="px-2 py-2">Station Name</th>
                                        <th class="text-center px-2 py-2">Year</th>
                                        <th class="text-center px-2 py-2">Month</th>
                                        <th class="text-center px-2 py-2">COA Id</th>
                                        <th class="px-2 py-2">COA Name</th>
                                        <th class="text-center px-2 py-2">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, idx) in reportdata?.data?.bottom" :key="idx+'-'+item.StationId+item.COAId">
                                        <td class="text-center align-top px-1 py-2">{{ ++idx }}</td>
                                        <td class="align-top px-2 py-2">{{ item.StationId }}</td>
                                        <td class="align-top px-2 py-2">{{ item.StationName }}</td>
                                        <td class="text-center align-top px-2 py-2">{{ item.Year }}</td>
                                        <td class="text-center align-top px-2 py-2">{{ item.Month }}</td>
                                        <td class="text-center align-top px-2 py-2">{{ item.COAId }}</td>
                                        <td class="align-top px-2 py-2">{{ item.COAName }}</td>
                                        <td class="text-right align-top px-2 py-2">{{ formatNum(item.Amount) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </el-card>
                </div>

                <div class="col-md-12 mb-4">
                    <el-card shadow="hover">
                        <div>
                            <h5>PETTY CASH SUMMARY YTD {{ overviewdata?.data?.summary_ytd?.Year }}</h5>
                        </div>
                        <div>
                            <BarChart :data="chartsummary" :width="500" :height="380"/>
                            <Loader v-if="loading.overview" />
                        </div>
                    </el-card>
                </div>

                <div class="col-md-12 mb-4">
                    <el-card shadow="hover">
                        <div>
                            <h5>PETTY CASH SUMMARY YTD {{ overviewdata?.data?.summary_ytd?.Year }} BY SALES AREA</h5>
                        </div>
                        <div>
                            <BarChart :data="chartsummarybysalesarea" :width="500" :height="380"/>
                            <Loader v-if="loading.overview" />
                        </div>
                    </el-card>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import Finance from '@/components/page/Finance.js'
import ReportResultTable from '@/views/pages/ReportResultTableHutang.vue'
import { Rainbow, FuelColor, Config, AppColors, Penanggalan, AxiosWithJar } from '@/utility.js'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'
import Loader from '@/components/loader/Loader2.vue'

export default
{
	extends: Finance,
	props: ['tabIndex','tabName', 'tabLabel'],
	components: { 
		//ReportParamSelect,
		//ReportResultTable,
		//LineChart,
		BarChart,
		Loader,
	},

	data(){
		return {
            isChildRoute: false,
            reportdata: [],
            overviewdata: [],
            chartdata: [],
            chartsummary: [],
            chartsummarybysalesarea: [],
			limit: 100,
            loading: {
                overview: false,
                topbottom: false,
                isSuccess: false,
            },
            stacked: false,
		}
	},
	watch: {
        $route(to, from) {
            this.hideNonChildren();
        }
	}, 
    mounted() {
        this.hideNonChildren();
        //this.getTopBottom();
        this.getOverview();
    },
    methods: {
        hideNonChildren() {
            this.isChildRoute = this.$route.path !== '/finance/pettycash';
        },

        async getOverview() {
            //
			this.urlRequestParams=Config().apiURL
            this.urlRequestParams+='/v1/pettycash/overview?'
            //this.urlRequestParams+='&count=8' 

			this.loading.overview = true
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
                    //this.loading.isSuccess = true
					this.overviewdata = response.data;
                    //if(response.data) {
                        this.chartsummary = this.processBarChart(this.overviewdata.data.summary_monthly, "Year", "", "Amount", false, "MonthName", "", 1, 2, AppColors, false, false, false, this.stacked);
                        this.chartsummarybysalesarea = this.processBarChart(this.overviewdata.data.summary_monthly_by_sales_area, "SalesArea", "Area ", "Amount", false, "MonthName", "", 1, 2, AppColors, false, false, false, this.stacked);
                    //}
				})
				.catch(error => {
					//console.log(error)
                    this.loading.isSuccess = false
                    this.overviewdata = []
                    let errMsg = error
                    this.$alert(errMsg, 'Error', {
                        confirmButtonText: 'Close',
                        callback: action => {
                            this.$message({
                            type: 'danger',
                            message: `Please try again.`
                            });
                        }
                    });
				})
				.finally(() => {
					this.loading.overview = false;
				})
		},

        async getTopBottom(){
			this.urlRequestParams=Config().apiURL
            this.urlRequestParams+='/v1/pettycash/topbottom?'
            //this.urlRequestParams+='&count=8' 

			this.loading.topbottom = true
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
                    //this.loading.isSuccess = true
					this.reportdata = response.data;
                    
				})
				.catch(error => {
					//console.log(error)
                    this.loading.isSuccess = false
                    this.reportdata = []
                    let errMsg = error
                    this.$alert(errMsg, 'Error', {
                        confirmButtonText: 'Close',
                        callback: action => {
                            this.$message({
                            type: 'danger',
                            message: `Please try again.`
                            });
                        }
                    });
				})
				.finally(() => {
					this.loading.topbottom = false;
				})
		},

    }
}
</script>

<style>
.table-pc-topbottom {
    width: 100%;
    font-size: 14px;
}

.table-pc-topbottom tbody tr:hover {
    background-color: #f2f2f2; /* Background color on hover */
    cursor: pointer;          /* Change cursor to pointer */
}
</style>